import './bootstrap'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'
import './assets/css/main.less'
import 'material-symbols'
import AutoKanaPlugin from './directives/autokana'

import.meta.glob(['../js/assets/img/favicon.svg'])

const pinia = createPinia()
const app = createApp(App)
app.use(pinia)
app.use(router)
app.use(AutoKanaPlugin)
app.mount('#app')
